import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

type Lookup = {
    value: string
    label: {
        th: string
        en: string
    }
}

const useSort = () => {
    const callApi = useCallApi()
    const [sorts, setSort] = useState<Lookup[]>([
        {
            value: 'desc',
            label: {
                th: 'ล่าสุด',
                en: 'descending ',
            },
        },
        {
            value: 'asc',
            label: {
                th: 'เก่าสุด',
                en: 'ascending',
            },
        },
    ])

    return { sorts: sorts }
}

export default useSort
